<template>
  <!-- 页面广告植入 -->
  <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
    :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <div>
    <el-button v-if="false" size="large" type="primary" @click="addFnc($event,'add')"
      ><el-icon><Plus /></el-icon>添加</el-button
    >
    <span style="margin-left: 20px"
      ><el-icon class="i_img"><Picture /></el-icon>广告图投放位置：</span
    >
    <el-select
      v-model="value"
      filterable
      clearable
      placeholder="请选择"
      @change="changeHandle(value)"
    >
      <el-option
        v-for="item in showPositionType"
        :key="item.id"
        :label="item.value"
        :value="item.key"
      >
      </el-option>
    </el-select>

    <!-- 面板详情 -->
    <div class="contain" :style="{ height: tableMaxHeight + 'px' }">
      <template v-if="tableData && tableData.length > 0">
        <ul v-for="item in tableData" :key="item.id">
          <li class="detail">
            <div class="label-name">
              <el-tooltip :content="item.name" placement="top">
                <el-image
                  style="width: 200px; height: 100px; border-radius: 12px"
                  :src="item.url"
                  :preview-src-list="[item.url]"
                  fit="cover"
                  close-on-press-escape
                  hide-on-click-modal
                />
              </el-tooltip>
            </div>
            <div class="detail-content">
              <div>
                <span class="label-left">广告图投放位置：</span>
                <span
                  >{{ item.bannerPositionName }}</span
                >
              </div>
              <div class="link-url">
                <span class="label-left">跳转URL：</span>
                <span v-if="item.link">
                  <a class="blue hand" :href="item.link" target="_blank">点击跳转</a>
                </span>
                <span class="noData" v-else>未设置</span>
              </div>
              <div>
                <span class="label-left">是否新窗口打开：</span>
                <span>{{ item.isOtherOpen == true ? "是" : "否" }}</span>
              </div>
              <div>
                <span class="label-left">操作老师：</span>
                <span :class="adminName ? '' : 'gray'">{{
                  adminName ? adminName : "未设置"
                }}</span>
              </div>
                <div>
                <span class="label-left">操作时间：</span>
                <span>{{ item.updateTime }}</span>
              </div>
                <div class="label-notes">
                <span class="label-left">备注说明：</span>
                 <el-tooltip
                 :disabled="!item.remarks"
                 effect="dark"
                 placement="top-start"
                  >
                   <template #content> 
                    <div class="notesForTip" :class="item.remarks ? '' : 'gray'">{{ item.remarks ? item.remarks : '未填写' }}</div>
                  </template>
                  <div class="notes" :class="item.remarks ? '' : 'gray'">{{ item.remarks ? item.remarks : '未填写' }}</div>
            </el-tooltip>
              </div>
            </div>
            <div class="detail-button">
               <el-button v-for="(item1,index) in buttonList" :key="index" :type="item1.className" @click="doEvent(item1.eventName, item)" :plain="!item1.isPlain">{{ item1.name }}</el-button>
            </div>
          </li>
        </ul>
      </template>
      <i v-else style="color: gray; margin: auto">暂无数据</i>
    </div>

    <!-- 添加编辑广告植入 -->
    <el-dialog
      :title="dialogTitle"
      v-model="addEditVisible"
      width="750px"
      class="abow_dialog"
      :before-close="beforeClose"
      :close-on-click-modal="false"
       draggable
              destroy-on-close
    >
      <div class="abow_dialog">
        <addEditAdv
          ref="AddEditRef"
          v-if="addEditVisible"
          class="table_dialog"
          :showPositionType="showPositionType"
          :EditInfo="EditInfo"
          :isEdit="isEdit"
          @update-list="updateList"
          @close-dialog="closeDialog"
        ></addEditAdv>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GetList, AllBannerPositions, Delete } from "network/advertisingImages";
import addEditAdv from "views/advertisingImages/addEditAdv.vue";
import { isNull } from "../../common/utils";
import { ref, reactive, onMounted, toRefs, computed, toRaw ,h, nextTick} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import store from "../../store/index";
export default {
  name: "AdvertisingImages",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    addEditAdv,
  },
  setup() {
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      emptyText: "暂无数据",
      value: "",
      tableData: [],
      // 表格是否在加载中
      tableLoading: false,
      loadingText: "loading...", //加载状态提示文本
      search: {
        Title: "",
        Type: null,
      },
      showPositionType: [],
      dialogTitle: "添加",
      addEditVisible: false,
      multipleSelection:[],
      EditInfo: {},
      isEdit: false,
      adminName: store.state.AdminCache.name, //暂时使用登陆人姓名 后端没有作者名字
    });

    onMounted(() => {
      getListData(); //列表
      getTypeAll(); //广告图投放位置
    });

    // 广告图投放位置
    const getTypeAll = async () => {
      const result = await AllBannerPositions();
      if (result && result.code == 1) {
        data.showPositionType = result.result;
      } else {
        ElMessage.error(result.message);
      }
    };

 // 广告图投放位置：
    const changeHandle = (value) => {
      data.search.Type = value;
      getListData();
    };

    // 请求列表数据
    const getListData = async () => {
      data.tableLoading = true;
      const res = await GetList(data.search);
      data.tableLoading = false;
      if (res && res.code == 1) {
        data.tableData = res.result.items;
      } else {
        ElMessageBox.alert(res.message, "恢复", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    };

    // 添加
    const addFnc = async () => {
        data.isEdit = false;
        data.dialogTitle = "添加页面植入广告";
        data.addEditVisible = true;
    };

    // 编辑
    const editFnc = () => {
      data.dialogTitle = "编辑页面植入广告";
      data.isEdit = true;
      data.EditInfo = data.multipleSelection[0];
      data.addEditVisible = true;
    };

    // 删除单条
    const deleteFnc = () => {
        const obj = toRaw(data.multipleSelection[0]);
         ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${obj.name}`
          ),
          h("span", null, "】广告图？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            Delete(obj.id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                // ElMessage.success(result.message);
                // updateList();
                ElMessageBox.alert("删除成功", {
                  confirmButtonText: "确定",
                  callback: (action) => {},
                });
                getListData();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessageBox.alert(err.message, {
                confirmButtonText: "确定",
                callback: (action) => {},
              });
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   Delete(obj.id).then((res) => {
        //     if (res && res.code === 1) {
        //       ElMessageBox.alert("删除成功", {
        //         confirmButtonText: "确定",
        //         callback: (action) => {},
        //       });
        //       getListData();
        //     } else {
        //       ElMessageBox.alert(res.message, {
        //         confirmButtonText: "确定",
        //         callback: (action) => {},
        //       });
        //     }
        //   });
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };

    // 刷新
    const updateList = () => {
      getListData();
    };
   
    // 关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };
    const AddEditRef = ref();
    const beforeClose = () => {
      data.addEditVisible = false;
      AddEditRef.value.onCancel();
    };
     const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
      }
    };
    
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      closeDialog,
      AddEditRef,
      beforeClose,
      changeHandle,
      getListData,
      addFnc,
      editFnc,
      deleteFnc,
      updateList,
      btnLeftList,
      buttonList,
      btnInTable,
      btnOnList,
      btnHandle,
      doEvent,
    };
  },
};
</script>

<style scoped>
.i_img {
  vertical-align: middle;
}
.abow_dialog >>> .el-dialog {
  height: 620px;
  overflow: hidden;
  position: relative;
}

::v-deep .abow_dialog .el-dialog__body {
  padding: 20px 0;
}
.contain {
  background: #f5f6fa;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  padding-bottom: 30px;
}

.detail {
  width: 500px;
  height: 400px;
  border-radius: 20px;
  box-shadow: 10px 10px 5px rgb(238, 236, 236);
  background: #fff;
  margin: 30px 15px 0px 15px;
  line-height: 30px;
  padding: 15px 20px 0 15px;
  box-sizing: border-box;
  /* overflow-y: scroll; */
  position: relative;
}
.label-left {
  color: #c0c0c0;
}

.noData {
  color: #c0c0c0;
}
.focusMap {
  width: 300px;
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
::-webkit-scrollbar {
  width: 2px !important;
}
.label-name {
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
}
.label-name img {
  width: 200px;
  height: 100px;
  border-radius: 10px;
}
.detail-content {
  /* height: 200px;
  overflow-y: scroll; */
}
.link-url {
  width: 400px;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.banner-url {
  width: 400px;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.detail-button {
  text-align: center;
  margin-top: 15px;
}

.label-notes{
  display: flex;
}
.notesForTip{
  max-width: 360px;
   word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    max-height: 100px;
    overflow-y: scroll;
}
.notes{
  max-width: 360px;
   word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}

::v-deep.el-tooltip__popper {
   max-width: 300px !important;
   overflow: hidden;
}
</style>